import { makeStyles } from "@mui/styles";
// import { opacity2hex } from "utils/miscUtils";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: "20px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    backgroundColor: "#f9f9f9",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
    },
  },

  smallField: {
    width: 120,
  },
  field: {
    width: 220,
  },
  button: {
    width: "150px",
    height: 45,
  },
  submitButton: {
    marginTop: 20,
    width: "150px",
    height: 45,
  },
  savecancel: {
    marginTop: 20,
    width: "100px",
    height: 40,
  },
  buttonContainer: {
    display: "flex",
    gap: 10,
  },
  firstFormContainer: {
    display: "flex",
    flexFlow: "row wrap",
    gap: 4,
    margin: "0px 0px 10px 0px",
  },
  secondFormContainer: {
    display: "flex",
    flexFlow: "row wrap",
    gap: 25,
    margin: "10px 0px 20px 0px",
  },
  requestContainer: {
    display: "flex",
    flexFlow: "column nowrap",
    gap: 15,
  },
  jsonEditorContainer: {
    position: "relative",
    width: "100%",
  },
  jsonEditorHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  jsonEditorLabel: {
    fontSize: "14px",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  jsonValidIcon: {
    fontSize: "18px",
  },
  jsonEditorActions: {
    display: "flex",
    gap: "8px",
  },
  jsonTextField: {
    fontFamily: "'Consolas', 'Monaco', 'Menlo', 'Ubuntu Mono', monospace",
    fontSize: "14px",
    lineHeight: "1.6",
    fontWeight: 400,
    letterSpacing: "0.5px",
  },
  jsonError: {
    color: theme.palette.error.main,
    fontSize: "12px",
    marginTop: "4px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  jsonHelperText: {
    fontSize: "11px",
    color: theme.palette.text.secondary,
    marginTop: "4px",
    fontStyle: "italic",
  },
  rotationConfigContainer: {
    width: "100%",
    border: "1px solid #ddd",
    borderRadius: "8px",
    padding: "16px",
    marginTop: "16px",
    backgroundColor: "#fff",
  },
  rotationConfigTitle: {
    fontSize: "14px",
    fontWeight: 600,
    marginBottom: "12px",
  },
  rotationConfigFields: {
    display: "flex",
    flexFlow: "row wrap",
    gap: "16px",
    marginTop: "12px",
    alignItems: "flex-start",
  },
  rotationConfigHelperText: {
    fontSize: "11px",
    color: theme.palette.text.secondary,
    marginTop: "4px",
    fontStyle: "italic",
  },
  failureRetryConfigContainer: {
    width: "100%",
    border: "1px solid #ddd",
    borderRadius: "8px",
    padding: "16px",
    marginTop: "16px",
    backgroundColor: "#fff",
  },
  failureRetryConfigTitle: {
    fontSize: "14px",
    fontWeight: 600,
    marginBottom: "12px",
  },
  failureRetryConfigFields: {
    display: "flex",
    flexFlow: "row wrap",
    gap: "16px",
    marginTop: "12px",
    alignItems: "flex-start",
  },
  failureRetryConfigHelperText: {
    fontSize: "11px",
    color: theme.palette.text.secondary,
    marginTop: "4px",
    fontStyle: "italic",
  },
}));

export default useStyles;
